var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6858 11.5123L6.38403 10.0498V20.8566C6.38393 20.974 6.40702 21.0903 6.45197 21.1989C6.49692 21.3074 6.56285 21.4059 6.64597 21.4889C6.72909 21.5719 6.82778 21.6377 6.93637 21.6824C7.04497 21.7272 7.16133 21.7501 7.27878 21.7498H21.6038C21.7214 21.7503 21.8379 21.7276 21.9467 21.6829C22.0554 21.6382 22.1543 21.5725 22.2376 21.4895C22.3209 21.4065 22.3869 21.3078 22.432 21.1992C22.477 21.0906 22.5001 20.9741 22.5 20.8566V16.8748L14.6858 11.5123Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6858 2.25H7.27878C7.16133 2.24971 7.04497 2.2726 6.93637 2.31736C6.82778 2.36213 6.72909 2.42789 6.64597 2.51088C6.56285 2.59386 6.49692 2.69244 6.45197 2.80096C6.40702 2.90947 6.38393 3.0258 6.38403 3.14325V7.125L14.6858 12L19.0815 13.4625L22.5 12V7.125L14.6858 2.25Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38403 7.125H14.6858V12H6.38403V7.125Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.3255 6.1499H6.38403V18.3374H12.3255C12.5623 18.3362 12.789 18.2418 12.9567 18.0746C13.1243 17.9074 13.2193 17.6809 13.221 17.4442V7.04315C13.2193 6.80641 13.1243 6.57989 12.9567 6.4127C12.789 6.2455 12.5623 6.15108 12.3255 6.1499Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8373 6.6377H6.38403V18.8252H11.8373C12.074 18.824 12.3008 18.7296 12.4684 18.5624C12.636 18.3952 12.731 18.1687 12.7328 17.9319V7.53095C12.731 7.2942 12.636 7.06769 12.4684 6.90049C12.3008 6.73329 12.074 6.63887 11.8373 6.6377Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8373 6.6377H6.38403V17.8502H11.8373C12.074 17.849 12.3008 17.7546 12.4684 17.5874C12.636 17.4202 12.731 17.1937 12.7328 16.9569V7.53095C12.731 7.2942 12.636 7.06769 12.4684 6.90049C12.3008 6.73329 12.074 6.63887 11.8373 6.6377Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.349 6.6377H6.38403V17.8502H11.349C11.5858 17.849 11.8125 17.7546 11.9802 17.5874C12.1478 17.4202 12.2428 17.1937 12.2445 16.9569V7.53095C12.2428 7.2942 12.1478 7.06769 11.9802 6.90049C11.8125 6.73329 11.5858 6.63887 11.349 6.6377Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3955 6.6377H11.349C11.5862 6.6375 11.8137 6.73148 11.9816 6.89897C12.1496 7.06647 12.2441 7.29378 12.2445 7.53095V16.4695C12.2441 16.7066 12.1496 16.9339 11.9816 17.1014C11.8137 17.2689 11.5862 17.3629 11.349 17.3627H2.3955C2.27798 17.3631 2.16154 17.3403 2.05286 17.2956C1.94418 17.2508 1.84541 17.1851 1.7622 17.1021C1.679 17.0191 1.613 16.9205 1.56801 16.8119C1.52301 16.7034 1.4999 16.587 1.5 16.4695V7.53095C1.4999 7.41343 1.52301 7.29705 1.56801 7.18848C1.613 7.07991 1.679 6.9813 1.7622 6.89831C1.84541 6.81531 1.94418 6.74957 2.05286 6.70485C2.16154 6.66012 2.27798 6.63731 2.3955 6.6377Z",
    fill: "url(#paint0_linear_542_386)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27502 14.9047L6.15827 11.9917L4.43327 9.09521H5.81852L6.75977 10.95C6.84677 11.1255 6.90977 11.256 6.93827 11.343H6.95102C7.01252 11.2025 7.07752 11.066 7.14602 10.9335L8.15252 9.09821H9.42752L7.65827 11.9782L9.47252 14.907H8.11577L7.02827 12.8737C6.97792 12.7862 6.93502 12.6946 6.90002 12.6H6.88202C6.85024 12.6922 6.80796 12.7806 6.75602 12.8632L5.63627 14.9047H4.27502Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6045 2.25001H14.6858V7.125H22.5V3.14325C22.5001 3.02573 22.477 2.90935 22.432 2.80079C22.387 2.69222 22.321 2.59361 22.2378 2.51061C22.1546 2.42762 22.0559 2.36187 21.9472 2.31715C21.8385 2.27243 21.7221 2.24961 21.6045 2.25001Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6858 12H22.5V16.875H14.6858V12Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_542_386",
    x1: 3.3705,
    y1: 5.9357,
    x2: 10.374,
    y2: 18.0647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excelIcon.dcb138c8077050c1246c661b1325fa63.svg";
export { ForwardRef as ReactComponent };